import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgListSheet({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 3a3 3 0 013 3v12a3 3 0 01-3 3H7a3 3 0 01-3-3V6a3 3 0 013-3h10zm0 2H7a1 1 0 00-1 1v12a1 1 0 001 1h10a1 1 0 001-1V6a1 1 0 00-1-1zM9 15a1 1 0 110 2 1 1 0 010-2zm6 0a1 1 0 110 2h-2a1 1 0 110-2h2zm-6-4a1 1 0 110 2 1 1 0 010-2zm6 0a1 1 0 110 2h-2a1 1 0 110-2h2zM9 7a1 1 0 110 2 1 1 0 010-2zm6 0a1 1 0 110 2h-2a1 1 0 110-2h2z"
        fill={color}
      />
    </svg>
  )
}

export default SvgListSheet
